import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ClearRowButton = ({ onClear, title }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    if (window.confirm(`「${title}」の全ての値をクリアしてもよろしいですか？`)) {
      onClear();
    }
  };

  return (
    <div
      className="clear-row-button-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        paddingRight: '25px'
      }}
    >
      <span style={{ flex: 1 }}>{title}</span>
      <button
        className="btn btn-sm clear-row-button"
        onClick={handleClick}
        style={{
          position: 'absolute',
          right: '2px',
          top: '50%',
          transform: 'translateY(-50%)',
          padding: '0 6px',
          fontSize: '16px',
          lineHeight: '1.2',
          backgroundColor: '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
          opacity: isHovered ? 1 : 0,
          visibility: isHovered ? 'visible' : 'hidden',
          transition: 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out',
          zIndex: 1001
        }}
        title={`${title}をクリア`}
      >
        ×
      </button>
    </div>
  );
};

ClearRowButton.propTypes = {
  onClear: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default ClearRowButton;